import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import { ContactCTA } from '../Contact'
import CarouselComponent from '../Carousel'

import './style.css'

function Banner(props) {
    return (
        <Container className="banner">
            <Row xs={1} sm={2} className="bannerRow">
                <Col className="my-auto textContainerBanner">
                    <div>
                        <div className='title'>{props.data.header}</div>
                        <h1>{props.data.text}</h1>
                        {props.data.cta ? <ContactCTA /> : <></>}
                    </div>

                </Col>
                <Col>
                    <Image className="image-container-glow" src={props.data.image} fluid />
                </Col>
            </Row>
        </Container>
    )
}

function BannerCarousel(props) {
    return (
        <Container className="bannerCarousel">
            <Row xs={1} sm={2} className="bannerRow">
                <Col className="my-auto textContainerBanner">
                    <div>
                        <h1 >{props.data.header}</h1>
                        <h4>{props.data.text}</h4>
                        {props.data.cta ? <ContactCTA /> : <></>}
                    </div>

                </Col>
                <Col >
                    <CarouselComponent data={props.data.carousel} />
                </Col>
            </Row>
        </Container>
    )
}

export default Banner
export { BannerCarousel }